// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DownloadDocumentRequestModel from '../../model/download-document-request-model';
import DownloadDocumentRequestDTO from '../dto/download-document-request-dto';

export default abstract class DownloadDocumentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DownloadDocumentRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;

  static toModel(dto: DeepPartial<DownloadDocumentRequestDTO>): DownloadDocumentRequestModel;
  static toModel(dto: DeepPartial<DownloadDocumentRequestDTO> | undefined | null): DownloadDocumentRequestModel | undefined;
  static toModel(dto: DeepPartial<DownloadDocumentRequestDTO> | undefined | null): DownloadDocumentRequestModel | undefined {
    return dto ? new DownloadDocumentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DownloadDocumentRequestModel> | DownloadDocumentRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
    } as DownloadDocumentRequestDTO;
  }
}
